import React, { createContext, useContext, useState } from 'react';

const AuthModalContext = createContext(null);

export const AuthModalProvider = ({ children }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const openLoginModal = () => setShowLoginModal(true);
  const closeLoginModal = () => setShowLoginModal(false);
  const openRegisterModal = () => setShowRegisterModal(true);
  const closeRegisterModal = () => setShowRegisterModal(false);
  const switchToRegister = () => { setShowLoginModal(false); setShowRegisterModal(true); };
  const switchToLogin = () => { setShowRegisterModal(false); setShowLoginModal(true); };

  return (
    <AuthModalContext.Provider value={{
      showLoginModal,
      showRegisterModal,
      openLoginModal,
      closeLoginModal,
      openRegisterModal,
      closeRegisterModal,
      switchToRegister,
      switchToLogin,
    }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => useContext(AuthModalContext);
